import type { CSSProperties } from "react";
import type { Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";
import type { HouseVisitSlotCalendarEvent } from "./types";

/** Empty → partial → full capacity. */
export function houseVisitSlotEventShellStyle(
  theme: Theme,
  event: HouseVisitSlotCalendarEvent
): CSSProperties {
  const { fillRatio } = event;
  if (fillRatio <= 0) {
    return {
      backgroundColor: alpha(
        theme.palette.text.primary,
        theme.palette.mode === "dark" ? 0.22 : 0.12
      ),
      color: theme.palette.text.primary,
      border: `1px solid ${theme.palette.divider}`,
    };
  }
  if (fillRatio >= 1) {
    return {
      backgroundColor: theme.palette.success.main,
      color: theme.palette.success.contrastText,
    };
  }
  return {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  };
}
